import React from 'react'
import { Button } from '../../../../components/Button'
import { AbsoluteCenter, Box, Divider, Flex, Text, useToast } from '@chakra-ui/react'
import { Controller, useFormContext } from 'react-hook-form'
import { gerarGpt } from '../functions/gerarGpt'
import { useMutation } from 'react-query'
import { TextEditor } from '../../../../components/TextEditor'

export const ListaDuvidas = ({ nomeCidade }) => {
  const { control, setValue } = useFormContext()

  const toast = useToast({
    position: 'top-right',
  })

  const { mutateAsync: gerarGptAsync, isLoading: isLoadingGerarGpt } = useMutation({
    mutationFn: gerarGpt,
    onSuccess: (data) => {
      const { campo, conteudo } = data

      toast({
        title: 'Conteúdo gerado com sucesso!',
        description: `Campo: ${campo}`,
        status: 'success',
      })

      if (campo === 'descricao') {
        setValue('descricao', conteudo)
        return
      }

      if (campo === 'topicos') {
        setValue('duvidas.topicos', conteudo)
        return
      }

      if (campo === 'duvidas') {
        setValue('duvidas.descricao', conteudo)
        return
      }

      if (campo === 'faq') {
        setValue('faq', conteudo)
        return
      }

      if (campo === 'secao_principal') {
        setValue('secao_principal.descricao', conteudo)
        return
      }

      if (campo === 'sub_secao') {
        setValue('sub_secao.descricao', conteudo)
        return
      }

      if (campo === 'sobre') {
        setValue('sobre.descricao', conteudo)
        return
      }
    },
    onError: () => {
      toast({
        title: 'Erro ao gerar conteúdo',
        status: 'error',
      })
    },
  })

  return (
    <>
      <Flex flexDir={'column'} gap={5}>
        <Box position="relative" padding="10">
          <Divider orientation="horizontal" borderColor="gray.300" borderWidth="1px" borderStyle="solid" />

          <AbsoluteCenter bg="white" px="4">
            Dúvidas
          </AbsoluteCenter>
        </Box>

        <Button
          onClick={() => gerarGptAsync({ cidade: nomeCidade, campo: 'duvidas' })}
          colorScheme="blue"
          size="lg"
          bgColor="blue.500"
          isLoading={isLoadingGerarGpt}
          mr="auto"
        >
          Gerar Dúvidas (Descrição)
        </Button>
        <Text fontSize="23px" fontWeight="bold">
          Dúvidas - Título
        </Text>
        <Controller
          name={`duvidas.titulo`}
          control={control}
          render={({ field }) => <TextEditor height="50px" name={`duvidas.titulo`} {...field} placeholder="Resposta" />}
        />
      </Flex>
      <Flex flexDir={'column'} gap={5}>
        <Text fontSize="23px" fontWeight="bold">
          Dúvidas - Descrição
        </Text>
        <Controller
          name={`duvidas.descricao`}
          control={control}
          render={({ field }) => <TextEditor height="100px" name={`duvidas.descricao`} {...field} placeholder="Resposta" />}
        />
      </Flex>
    </>
  )
}
